"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.augmentedCorrespondenceSchema = void 0;
var constants_1 = require("@hobt/constants");
var constants_2 = require("../../constants");
var correspondence_schema_1 = require("./correspondence-schema");
exports.augmentedCorrespondenceSchema = __assign(__assign({}, correspondence_schema_1.correspondenceSchema), { required: __spreadArrays(correspondence_schema_1.correspondenceSchema.required, ['claimID']), properties: __assign(__assign({}, correspondence_schema_1.correspondenceSchema.properties), { claimID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        }, claimStatus: {
            type: ['number', 'null'],
            enum: __spreadArrays(Object.values(constants_2.InternalClaimStatus), [null]),
            errorMessage: 'Should equate to a valid InternalClaimStatus Enum value or null',
        }, claimTypeCode: {
            type: ['string', 'null'],
            enum: __spreadArrays(Object.values(constants_2.ClaimTypeCode), [null]),
            errorMessage: 'Should equate to a valid ClaimTypeCode Enum value or null',
        }, cmhcLoanAccountNumber: {
            type: ['number', 'null'],
            minimum: 10000000,
            maximum: 99999999,
            errorMessage: 'should be a numeric value with 8 digits or null',
        }, sequenceNumber: {
            type: ['number', 'null'],
            minimum: 0,
            maximum: 2147483647,
            errorMessage: 'Should be an integer between 0 and 2147483647 or null',
        }, recordCreatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'Should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        }, recordCreatedUserID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        }, recordUpdatedTimestamp: {
            type: 'string',
            pattern: '^(\\d{4}-\\d{2}-\\d{2})(-| )(\\d{2})(:|.)(\\d{2})(:|.)(\\d{2})(.)(\\d{1,6})$',
            errorMessage: 'Should have date-time format YYYY-MM-DD 00:00:00.000000, YYYY-MM-DD 00.00.00.000000, YYYY-MM-DD-00.00.00.000000',
        }, recordUpdatedUserID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        }, claimSubmitterUserID: {
            type: 'string',
            format: 'uuid',
            errorMessage: 'should follow UUID format 00000000-0000-0000-0000-000000000000',
        }, claimTypeCodeDescription: {
            type: 'string',
            errorMessage: 'should be a string',
        }, commentLink: {
            type: 'string',
            errorMessage: 'should be a string',
        }, email: {
            type: 'string',
            pattern: '^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-.]+$',
            minLength: 1,
            maxLength: 80,
            errorMessage: {
                maxLength: 'Should be an email with a maximum of 80 characters',
                pattern: constants_1.validationErrorMessage(constants_1.HbtValidationErrorCodes.HBT_VAL_ERR_MUST_BE_A_VALID_EMAIL_FORMAT),
            },
        }, language: {
            type: 'string',
            enum: Object.values(constants_1.LanguageShort),
            errorMessage: 'Should equate to a valid LanguageShort Enum value',
        } }) });
